import { useClube } from '../contextClube'
import { GoPlus } from 'react-icons/go'
import { CardProperties } from './CardProperties'
import { SpaceLoader } from '../../../../loaders/spaceLoader'

import { Container, Button } from "./style"

export function MainPageProperties() {
    const { mainPageProperties, setModalFormsMainIsOpen, loading } = useClube()


    return(
        <Container>
            <h2>Configurações Gerais</h2>

            <div className="containerProperties">
                {
                    loading ? 
                    <SpaceLoader colorLoader="#535352" />

                    :

                    mainPageProperties.map(property => (
                        <CardProperties 
                            key={property.id}
                            border={property.bgColorHeader}
                            obj={property}
                        />
                    ))
                }
            </div>
            
            <Button onClick={() => setModalFormsMainIsOpen(true)}>
                <GoPlus />
            </Button>
        </Container>
    )
}